/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================
*/

// Material Kit 2 React pages
import OurServices from "pages/LandingPages/OurServices";

export default function OurServicesPage() {
  return <OurServices />;
}
